import { render } from "./PackageCard.vue?vue&type=template&id=58609d63&scoped=true"
import script from "./PackageCard.vue?vue&type=script&lang=js"
export * from "./PackageCard.vue?vue&type=script&lang=js"

import "./PackageCard.vue?vue&type=style&index=0&id=58609d63&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58609d63"]])

export default __exports__